import { render, staticRenderFns } from "./BaseMenuList.vue?vue&type=template&id=37c72f1e&scoped=true"
import script from "./BaseMenuList.vue?vue&type=script&lang=js"
export * from "./BaseMenuList.vue?vue&type=script&lang=js"
import style0 from "./BaseMenuList.vue?vue&type=style&index=0&id=37c72f1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c72f1e",
  null
  
)

export default component.exports